import authSlice from './auth-slice';
import translateSlice from './translate-slice';
import messagesSlice from './messages-slice';
import topicsSlice from './topic-slice';
import { initTexts } from './translate-actions';
import { configureStore } from '@reduxjs/toolkit';
import applicationSlice from './application-slice';
import errorHandlingSlice from '../components/lms-shared/store/error-handling-slice'
import curriculumSlice from './curriculum-slice';
import lessonSlice from './lesson-slice';
import generalSlice from './general-slice';
import signalRMessagesSlice from '../components/lms-shared/store/signalRMessages-slice';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        translate: translateSlice.reducer,
        messages: messagesSlice.reducer,
        signalRMessages:signalRMessagesSlice.reducer,
        topics: topicsSlice.reducer,
        application: applicationSlice.reducer,
        errorHandling: errorHandlingSlice.reducer,
        curriculums: curriculumSlice.reducer,
        lessons: lessonSlice.reducer,
        general: generalSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
});

export default store;

store.dispatch(initTexts());